import React, { useState, useMemo, useEffect, useRef } from "react";
import Footer from "../components/Layout/Footer";
import Header from "../components/Layout/Header";
import ALDOT from "../assets/ADOT.png";
import toast from "react-hot-toast";
import AxiosInstance from "../utils/axiosInstance";
import SaveSuccess from "../components/SaveSuccess";
import Select from "react-select";
const initialFormState = {
  legalName: "",
  primaryDba: "",
  secondaryDba: "",
  fein: "",
  mailingStreet: "",
  city: "",
  state: "",
  state_id: [],
  zip: "",
  businessPhone: "",
  website: "",
  ownerNames: "",
  email: "",
  phone: "",
  yearsInBusiness: "",
  providesProfessionalServices: "",
  professionalServicesType: "",
  holdsContractorLicense: "",
  licenseNumber: "",
  licenseClassification: "",
  sellsProducts: "",
  sellerPermitNumber: "",
  businessType: "",
  businessTypeOther: "",
  grossReceiptsAmount: "",
  grossReceiptsYear: "",
  personalNetWorth: "",
  descriptionOfWork: "",
};
export default function VendorFormPage() {
  const [formData, setFormData] = useState(initialFormState);

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false); // Success state
  const [companySuggestions, setCompanySuggestions] = useState([]);
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const suggestionRef = useRef(null);
  const [stateList, setStateList] = useState([]);
  const [selectedState, setSelectedState] = useState([]);
  // --- 1. Year Selection Logic ---
  const customSelectStyles = {
    control: (base) => ({
      ...base,
      border: "none",
      borderBottom: "1px solid black",
      borderRadius: 0,
      boxShadow: "none",
      minHeight: "12px",
      background: "transparent",
      margin: "0px",
    }),
    valueContainer: (base) => ({
      ...base,
      padding: "0 4px",
      margin: -4,
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: 0,
      color: "#a71e1e",
    }),
    menu: (base) => ({
      ...base,
      zIndex: 9999,
    }),
  };
  const transformData = (items) =>
    items.map(({ id, name }) => ({
      value: id,
      label: name,
    }));

  const getState = () => {
    AxiosInstance.get(
      `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_GET_STATE_API}`,
    )
      .then((response) => {
        if (response?.data?.data) {
          setStateList(transformData(response.data.data));
        }
      })
      .catch((error) => {
        console.log(error?.message);
      });
  };

  useEffect(() => {
    fetchCompanies();
    getState(); // 👈 add this
  }, []);
  const handleStateChange = (selectedOptions) => {
    // convert to array always
    const optionsArray = Array.isArray(selectedOptions)
      ? selectedOptions
      : selectedOptions
        ? [selectedOptions]
        : [];

    setSelectedState(optionsArray);

    setFormData((prev) => ({
      ...prev,
      state: optionsArray.map((opt) => opt.label).join(", "),
      state_id: optionsArray.map((opt) => opt.value),
    }));

    if (errors.state_id) {
      setErrors((prev) => ({ ...prev, state_id: "" }));
    }
  };
  const yearOptions = useMemo(() => {
    const currentYear = new Date().getFullYear();
    const startYear = 1900;
    const yearsArr = [];
    for (let i = currentYear; i >= startYear; i--) {
      yearsArr.push({ value: i.toString(), label: i.toString() });
    }
    return yearsArr;
  }, []);

  // --- 2. React-Select Styles ---
  const selectStyles = {
    control: (baseStyles) => ({
      ...baseStyles,
      border: "none",
      borderBottom: "1px solid black",
      borderRadius: "0",
      background: "transparent",
      boxShadow: "none",
      minHeight: "22px",
      "&:hover": {
        borderColor: "#2684FF",
      },
      padding: "0px",
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "0 4px",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: "0",
      color: "#a71e1e",
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      borderRadius: 0,
    }),
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleYearChange = (selectedOption) => {
    setFormData((prev) => ({
      ...prev,
      grossReceiptsYear: selectedOption ? selectedOption.value : "",
    }));
  };

  const handleInputChange = (e) => {
    const value = e.target.value;

    setFormData((prev) => ({
      ...prev,
      legalName: value,
    }));

    if (value.trim() === "") {
      setFilteredSuggestions(companySuggestions);
    } else {
      const filtered = companySuggestions.filter((item) =>
        item.toLowerCase().includes(value.toLowerCase()),
      );
      setFilteredSuggestions(filtered);
    }

    setShowSuggestions(true);
  };
  const validate = () => {
    let tempErrors = {};
    if (!formData.legalName?.trim())
      tempErrors.legalName = "Legal Business Name is required";
    if (!formData.fein?.trim()) tempErrors.fein = "FEIN is required";
    if (!formData.ownerNames?.trim())
      tempErrors.ownerNames = "Owner Name(s) are required";

    if (!formData.email?.trim()) {
      tempErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      tempErrors.email = "Invalid email format";
    }

    if (!formData.providesProfessionalServices) {
      tempErrors.providesProfessionalServices = "Please select an option";
    } else if (
      formData.providesProfessionalServices === "Yes" &&
      !formData.professionalServicesType?.trim()
    ) {
      tempErrors.professionalServicesType =
        "Please specify the type of services";
    }

    if (!formData.holdsContractorLicense) {
      tempErrors.holdsContractorLicense = "Please select an option";
    } else if (formData.holdsContractorLicense === "Yes") {
      if (!formData.licenseNumber?.trim())
        tempErrors.licenseNumber = "License number is required";
      if (!formData.licenseClassification?.trim())
        tempErrors.licenseClassification = "Classification is required";
    }

    if (!formData.sellsProducts) {
      tempErrors.sellsProducts = "Please select an option";
    } else if (
      formData.sellsProducts === "Yes" &&
      !formData.sellerPermitNumber?.trim()
    ) {
      tempErrors.sellerPermitNumber = "Seller's permit number is required";
    }

    if (!formData.businessType) {
      tempErrors.businessType = "Please select your business structure";
    } else if (
      formData.businessType === "Other" &&
      !formData.businessTypeOther?.trim()
    ) {
      tempErrors.businessTypeOther = "Please specify your business structure";
    }

    if (!formData.state || formData.state.length === 0) {
      tempErrors.state = "State is required";
    }
    console.log(tempErrors);
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };
  const handleSuggestionClick = (value) => {
    setFormData((prev) => ({
      ...prev,
      legalName: value,
    }));
    setShowSuggestions(false);
  };

  const fetchCompanies = async () => {
    const stored = localStorage.getItem("companies");
    if (stored) {
      setCompanySuggestions(JSON.parse(stored));
      return;
    }

    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const endpoint = process.env.REACT_APP_GET_COMPANIES;
      const res = await AxiosInstance.get(`${apiUrl}${endpoint}`);

      if (res?.data?.data) {
        const names = res.data.data.map((item) => item.name);
        setCompanySuggestions(names);
        localStorage.setItem("companies", JSON.stringify(names));
      }
    } catch (err) {
      console.error("Failed to fetch company names:", err);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        suggestionRef.current &&
        !suggestionRef.current.contains(event.target)
      ) {
        setShowSuggestions(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      const baseUrl = process.env.REACT_APP_API_URL || "";
      const endPoint = process.env.REACT_APP_VendorFormSubmit || "";
      const submitUrl = `${baseUrl}${endPoint}`.replace(/([^:]\/)\/+/g, "$1");

      AxiosInstance.post(submitUrl, formData)
        .then((response) => {
          toast.success(
            response?.data?.message || "Form submitted successfully!",
          );
          setSubmitted(true); // Show Success View
          setFormData(initialFormState); // Clear data
          setSelectedState(null); // Clear React-Select
        })
        .catch((error) => {
          toast.error(error?.response?.data?.message || "Something went wrong");
        });
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
      toast.error("Please fill in all required fields.");
    }
  };

  const inputStyle = (fieldName) => ({
    border: "none",
    borderBottom: errors[fieldName] ? "2px solid #dc3545" : "1px solid black",
    background: "transparent",
    outline: "none",
    padding: "0 4px",
    width: "100%",
    transition: "border-color 0.2s",
  });

  const textAreaStyle = {
    outline: "none",
    resize: "none",
    lineHeight: "32px",
    backgroundImage:
      "linear-gradient(transparent, transparent 31px, #ccc 31px)",
    backgroundSize: "100% 32px",
    border: "none",
    width: "100%",
  };

  const handleReset = () => {
    setFormData(initialFormState);
    setSelectedState(null); // Reset the React-Select dropdown
    setErrors({});
    setSubmitted(false); // Show Success View
    window.scrollTo({ top: 0, behavior: "instant" });
  };
  return (
    <>
      {/* Custom CSS for Printing Visibility */}
      <style>
        {`
          @media print {
            .d-print-none { display: none !important; }
            .d-print-block { display: block !important; }
            .d-print-flex { display: flex !important; }
            input { border-bottom: 1px solid black !important; }
            /* Hide the spin buttons on number input for PDF */
            input::-webkit-outer-spin-button, input::-webkit-inner-spin-button {
              -webkit-appearance: none; margin: 0;
            }
          }
        `}
      </style>

      <div className="bg-primary py-3 d-print-none">
        <Header />
      </div>

      <div className="bg-light py-5 text-dark">
        <div className="container">
          <div className="row justify-content-center">
            {submitted ? (
              <SaveSuccess
                onReset={handleReset}
                title="Success!"
                message="Your vendor information has been successfully added to our management system."
              />
            ) : (
              <form
                onSubmit={handleSubmit}
                className="col-12 col-lg-10 bg-white p-5 border border-2 border-dark shadow-lg"
              >
                {/* Header & Purpose */}
                <div className="text-center mb-5">
                  <img
                    src={ALDOT}
                    alt="ALDOT Logo"
                    style={{ width: "120px" }}
                    className="mb-3"
                  />
                  <h2 className="fw-bold">
                    Vendor and Opportunity Management System
                  </h2>
                  <h3 className="h5 text-muted mb-4">
                    Western Alabama Highway
                  </h3>

                  <div
                    className="p-3 bg-light border text-start mb-4"
                    style={{ fontSize: "0.9rem" }}
                  >
                    <p className="fw-bold mb-1">Purpose of This Form</p>
                    <p className="mb-0 text-muted">
                      This voluntary form allows businesses to provide
                      information to Alabama Department of Transportation for
                      inclusion in its Vendor and Opportunity Management System.
                      Submission of this form is not required and does not
                      constitute registration, certiﬁcation, or approval to
                      perform work. The information may be used to help identify
                      potential vendors and improve outreach eﬀorts.{" "}
                    </p>
                  </div>
                  <hr className="border-dark" />
                </div>

                {/* SECTION A: Business Information */}
                {/* SECTION A: Business Information */}
                <div className="mb-5">
                  <h4 className="fw-bold mb-4 text-primary">
                    SECTION A: Business Information
                  </h4>

                  {/* 1. Legal Business Name */}
                  <div className="mb-3 position-relative" ref={suggestionRef}>
                    <label className="fw-bold">1. Legal Business Name *</label>

                    <input
                      type="text"
                      name="legalName"
                      value={formData.legalName}
                      onChange={handleInputChange}
                      onFocus={() => setShowSuggestions(true)}
                      autoComplete="off"
                      style={inputStyle("legalName")}
                    />

                    {/* Suggestions */}
                    {showSuggestions && filteredSuggestions.length > 0 && (
                      <ul
                        className="list-group position-absolute w-100 z-3 shadow-sm"
                        style={{ maxHeight: "200px", overflowY: "auto" }}
                      >
                        {filteredSuggestions.map((suggestion, index) => (
                          <button
                            type="button"
                            key={index}
                            className="list-group-item list-group-item-action text-start"
                            onClick={() => handleSuggestionClick(suggestion)}
                          >
                            {suggestion}
                          </button>
                        ))}
                      </ul>
                    )}

                    {errors.legalName && (
                      <small className="text-danger">{errors.legalName}</small>
                    )}
                  </div>

                  {/* 2 & 3. DBA Names */}
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label>2. Primary DBA Name (if any)</label>
                      <input
                        type="text"
                        name="primaryDba"
                        value={formData.primaryDba}
                        onChange={handleChange}
                        style={inputStyle("primaryDba")}
                      />
                    </div>
                    <div className="col-md-6">
                      <label>3. Secondary DBA Name (if any)</label>
                      <input
                        type="text"
                        name="secondaryDba"
                        value={formData.secondaryDba}
                        onChange={handleChange}
                        style={inputStyle("secondaryDba")}
                      />
                    </div>
                  </div>

                  {/* 4. FEIN */}
                  <div className="mb-3 w-50">
                    <label className="fw-bold">
                      4. Federal Employer Identification Number (FEIN) *
                    </label>
                    <input
                      type="text"
                      name="fein"
                      value={formData.fein}
                      onChange={handleChange}
                      style={inputStyle("fein")}
                    />
                    {errors.fein && (
                      <small className="text-danger">{errors.fein}</small>
                    )}
                  </div>

                  {/* 5. Mailing Address */}
                  <div className="mb-4">
                    <label className="fw-bold">
                      5. Mailing Address (Street or P.O. Box):
                    </label>
                    <input
                      type="text"
                      name="mailingStreet"
                      value={formData.mailingStreet}
                      onChange={handleChange}
                      style={inputStyle("mailingStreet")}
                      className="mb-2"
                    />
                    <div className="row">
                      <div className="col-md-6">
                        <label>City:</label>
                        <input
                          type="text"
                          name="city"
                          value={formData.city}
                          onChange={handleChange}
                          style={inputStyle("city")}
                        />
                      </div>
                      <div className="col-md-3">
                        <label>ZIP:</label>
                        <input
                          type="text"
                          name="zip"
                          value={formData.zip}
                          onChange={handleChange}
                          style={inputStyle("zip")}
                        />
                      </div>
                      <div className="col-md-3">
                        <label>State:</label>

                        <Select
                          options={stateList}
                          // isMulti
                          value={selectedState}
                          onChange={handleStateChange}
                          placeholder="select states..."
                          isSearchable
                          styles={customSelectStyles}
                        />

                        {errors.state_id && (
                          <small className="text-danger">
                            {errors.state_id}
                          </small>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* 6. Business Phone & Website */}
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label>6. Business Phone:</label>
                      <input
                        type="text"
                        name="businessPhone"
                        value={formData.businessPhone}
                        onChange={handleChange}
                        style={inputStyle("businessPhone")}
                      />
                    </div>
                    <div className="col-md-6">
                      <label>Website:</label>
                      <input
                        type="text"
                        name="website"
                        value={formData.website}
                        onChange={handleChange}
                        style={inputStyle("website")}
                      />
                    </div>
                  </div>

                  {/* 7. Business Owner Name(s) */}
                  <div className="mb-3">
                    <label className="fw-bold">
                      7. Business Owner Name(s) *
                    </label>
                    <input
                      type="text"
                      name="ownerNames"
                      value={formData.ownerNames}
                      onChange={handleChange}
                      style={inputStyle("ownerNames")}
                    />
                    {errors.ownerNames && (
                      <small className="text-danger">{errors.ownerNames}</small>
                    )}
                  </div>

                  {/* 8. Email & Phone */}
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label className="fw-bold">8. Email *</label>
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        style={inputStyle("email")}
                      />
                      {errors.email && (
                        <small className="text-danger">{errors.email}</small>
                      )}
                    </div>
                    <div className="col-md-6">
                      <label>Phone:</label>
                      <input
                        type="text"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        style={inputStyle("phone")}
                      />
                    </div>
                  </div>

                  {/* 9. Years in Business */}
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label>9. Years in business:</label>
                      <input
                        type="text"
                        name="yearsInBusiness"
                        value={formData.yearsInBusiness}
                        onChange={handleChange}
                        style={inputStyle("yearsInBusiness")}
                      />
                    </div>
                  </div>

                  <hr className="border-dark" />
                </div>
                {/* SECTION B: Business Type & Operations */}
                <div className="mb-5">
                  <h4 className="fw-bold mb-4 text-primary">
                    SECTION B: Business Type & Operations
                  </h4>

                  {/* 1. Professional Services */}
                  <div className="mb-4">
                    <label className="d-block fw-bold">
                      1. Does this firm provide professional services?
                    </label>
                    <div className="d-flex gap-3 my-2 d-print-none">
                      <label className="cursor-pointer">
                        <input
                          type="radio"
                          name="providesProfessionalServices"
                          value="Yes"
                          checked={
                            formData.providesProfessionalServices === "Yes"
                          }
                          onChange={handleChange}
                        />{" "}
                        Yes
                      </label>
                      <label className="cursor-pointer">
                        <input
                          type="radio"
                          name="providesProfessionalServices"
                          value="No"
                          checked={
                            formData.providesProfessionalServices === "No"
                          }
                          onChange={handleChange}
                        />{" "}
                        No
                      </label>
                    </div>
                    {/* PRINT ONLY: Shows selection */}
                    <div className="d-none d-print-block fw-bold mb-2">
                      {formData.providesProfessionalServices || "Not Answered"}
                    </div>

                    {formData.providesProfessionalServices === "Yes" && (
                      <div className="ps-3 animate-fade-in mb-2 d-print-block">
                        <label>Type:</label>
                        <input
                          type="text"
                          name="professionalServicesType"
                          value={formData.professionalServicesType}
                          onChange={handleChange}
                          style={inputStyle("professionalServicesType")}
                          className="d-print-none"
                        />
                        <div className="d-none d-print-block border-bottom border-dark">
                          {formData.professionalServicesType || "________"}
                        </div>
                        {errors.professionalServicesType && (
                          <small className="text-danger d-block">
                            {errors.professionalServicesType}
                          </small>
                        )}
                      </div>
                    )}
                  </div>

                  {/* 2. Construction License */}
                  <div className="mb-4">
                    <label className="d-block fw-bold">
                      2. Does this firm hold a construction contractor's
                      license?
                    </label>
                    <div className="d-flex gap-3 my-2 d-print-none">
                      <label className="cursor-pointer">
                        <input
                          type="radio"
                          name="holdsContractorLicense"
                          value="Yes"
                          checked={formData.holdsContractorLicense === "Yes"}
                          onChange={handleChange}
                        />{" "}
                        Yes
                      </label>
                      <label className="cursor-pointer">
                        <input
                          type="radio"
                          name="holdsContractorLicense"
                          value="No"
                          checked={formData.holdsContractorLicense === "No"}
                          onChange={handleChange}
                        />{" "}
                        No
                      </label>
                    </div>
                    <div className="d-none d-print-block fw-bold mb-2">
                      {formData.holdsContractorLicense || "Not Answered"}
                    </div>

                    {formData.holdsContractorLicense === "Yes" && (
                      <div className="ps-3 row animate-fade-in d-print-flex">
                        <div className="col-md-6 mb-2">
                          <label>License #:</label>
                          <input
                            type="text"
                            name="licenseNumber"
                            value={formData.licenseNumber}
                            onChange={handleChange}
                            style={inputStyle("licenseNumber")}
                            className="d-print-none"
                          />
                          <div className="d-none d-print-block border-bottom border-dark">
                            {formData.licenseNumber || "________"}
                          </div>
                          {errors.licenseNumber && (
                            <small className="text-danger d-block">
                              {errors.licenseNumber}
                            </small>
                          )}
                        </div>
                        <div className="col-md-6 mb-2">
                          <label>License Classification(s):</label>
                          <input
                            type="text"
                            name="licenseClassification"
                            value={formData.licenseClassification}
                            onChange={handleChange}
                            style={inputStyle("licenseClassification")}
                            className="d-print-none"
                          />
                          <div className="d-none d-print-block border-bottom border-dark">
                            {formData.licenseClassification || "________"}
                          </div>
                          {errors.licenseClassification && (
                            <small className="text-danger d-block">
                              {errors.licenseClassification}
                            </small>
                          )}
                        </div>
                      </div>
                    )}
                  </div>

                  {/* 3. Product Sales */}
                  <div className="mb-4">
                    <label className="d-block fw-bold">
                      3. Does the firm sell products?
                    </label>
                    <div className="d-flex gap-3 my-2 d-print-none">
                      <label className="cursor-pointer">
                        <input
                          type="radio"
                          name="sellsProducts"
                          value="Yes"
                          checked={formData.sellsProducts === "Yes"}
                          onChange={handleChange}
                        />{" "}
                        Yes
                      </label>
                      <label className="cursor-pointer">
                        <input
                          type="radio"
                          name="sellsProducts"
                          value="No"
                          checked={formData.sellsProducts === "No"}
                          onChange={handleChange}
                        />{" "}
                        No
                      </label>
                    </div>
                    <div className="d-none d-print-block fw-bold mb-2">
                      {formData.sellsProducts || "Not Answered"}
                    </div>
                    {errors.sellsProducts && (
                      <small className="text-danger d-block">
                        {errors.sellsProducts}
                      </small>
                    )}
                    {formData.sellsProducts === "Yes" && (
                      <div className="ps-3 animate-fade-in mb-2 d-print-block">
                        <label>Seller’s permit number:</label>
                        <input
                          type="text"
                          name="sellerPermitNumber"
                          value={formData.sellerPermitNumber}
                          onChange={handleChange}
                          style={inputStyle("sellerPermitNumber")}
                          className="d-print-none"
                        />
                        <div className="d-none d-print-block border-bottom border-dark">
                          {formData.sellerPermitNumber || "________"}
                        </div>
                        {errors.sellerPermitNumber && (
                          <small className="text-danger d-block">
                            {errors.sellerPermitNumber}
                          </small>
                        )}
                      </div>
                    )}
                  </div>
                  <hr className="border-dark mt-5" />
                </div>

                {/* SECTION C: Business Structure */}
                <div className="mb-5">
                  <h4 className="fw-bold mb-4 text-primary">
                    SECTION C: Business Structure
                  </h4>
                  <div className="row g-3 ps-2 d-print-none">
                    {[
                      "Sole Proprietorship",
                      "Partnership",
                      "LLC",
                      "Corporation",
                      "LLP",
                      "Other",
                    ].map((opt) => (
                      <div className="col-md-6" key={opt}>
                        <label className="d-flex align-items-center gap-2 cursor-pointer">
                          <input
                            type="radio"
                            name="businessType"
                            value={opt}
                            checked={formData.businessType === opt}
                            onChange={handleChange}
                          />{" "}
                          {opt}
                        </label>
                      </div>
                    ))}
                  </div>
                  {/* Print View for Structure */}
                  <div className="d-none d-print-block fw-bold mb-2">
                    Structure: {formData.businessType || "Not Selected"}
                  </div>
                  {errors.businessType && (
                    <small className="text-danger d-block">
                      {errors.businessType}
                    </small>
                  )}

                  {formData.businessType === "Other" && (
                    <div className="mt-3 ps-2 d-print-block">
                      <label>Specify structure:</label>
                      <input
                        type="text"
                        name="businessTypeOther"
                        value={formData.businessTypeOther}
                        onChange={handleChange}
                        style={inputStyle("businessTypeOther")}
                        className="d-print-none"
                      />
                      <div className="d-none d-print-block border-bottom border-dark">
                        {formData.businessTypeOther || "________"}
                      </div>
                      {errors.businessTypeOther && (
                        <small className="text-danger d-block">
                          {errors.businessTypeOther}
                        </small>
                      )}
                    </div>
                  )}
                  <hr className="border-dark mt-4" />
                </div>

                {/* SECTION D: Gross Receipts (Year Picker Updated) */}
                <div className="mb-5">
                  <h4 className="fw-bold mb-2 text-primary">
                    SECTION D: Gross Receipts
                  </h4>
                  <h5 className="fw-bold mb-2 text-primary">
                    Registrants Business Gross Receipts
                  </h5>
                  <p
                    className="small text-muted mb-4"
                    style={{ textAlign: "justify", lineHeight: "1.4" }}
                  >
                    The information provided in this section is voluntary and
                    will be treated as confidential. It will be used for
                    internal program administration and analysis purposes only
                    and will not be published or released publicly.
                  </p>
                  <div className="row mb-3">
                    <div className="col-md-6 mb-3">
                      <label className="d-block">1. Annual Amount ($):</label>
                      <div className="d-flex align-items-end">
                        <span className="me-1">$</span>
                        <input
                          type="number"
                          name="grossReceiptsAmount"
                          value={formData.grossReceiptsAmount}
                          onChange={handleChange}
                          placeholder="0.00"
                          style={inputStyle()}
                        />
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="d-block fw-bold">YEAR :</label>
                      <div className="d-print-none">
                        <Select
                          options={yearOptions}
                          styles={selectStyles}
                          onChange={handleYearChange}
                          placeholder="Select Year"
                          isSearchable
                          value={yearOptions.find(
                            (opt) => opt.value === formData.grossReceiptsYear,
                          )}
                        />
                      </div>
                      {/* Plain text for PDF print */}
                      <div className="d-none d-print-block border-bottom border-dark pb-1">
                        {formData.grossReceiptsYear || "________"}
                      </div>
                      {errors.grossReceiptsYear && (
                        <small className="text-danger d-block">
                          {errors.grossReceiptsYear}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="mb-3">
                    <label className="d-block">
                      2. Personal Net Worth ($):
                    </label>
                    <div className="d-flex align-items-end w-50">
                      <span className="me-1">$</span>
                      <input
                        type="number"
                        name="personalNetWorth"
                        value={formData.personalNetWorth}
                        onChange={handleChange}
                        placeholder="0.00"
                        style={inputStyle()}
                      />
                    </div>
                  </div>
                </div>

                {/* SECTION E: Work Performed */}
                <div className="mb-5">
                  <h4 className="fw-bold mb-3 text-primary">
                    SECTION E: Work Performed/Provide
                  </h4>
                  <label className="mb-2">Description of work:</label>
                  <textarea
                    name="descriptionOfWork"
                    value={formData.descriptionOfWork}
                    onChange={handleChange}
                    rows="5"
                    style={textAreaStyle}
                  ></textarea>
                </div>

                {/* SECTION F: Disclaimer */}
                <div className="mb-5 p-4 bg-light border border-dark">
                  <h5 className="fw-bold mb-3">SECTION F: Disclaimer</h5>
                  <div
                    className="small text-muted"
                    style={{ fontSize: "0.85rem", textAlign: "justify" }}
                  >
                    <p>
                      Submission of this form is voluntary and is intended only
                      to provide business information for inclusion in the
                      Vendor and Opportunity Management System.
                    </p>
                    <p>
                      Providing this information does not constitute
                      registration, certification, prequalification, or approval
                      to perform work with the Alabama Department of
                      Transportation (ALDOT) or Western Alabama Highway.
                    </p>
                    <p>
                      Submission of this form does not create a contractual
                      relationship or obligation between the business and ALDOT
                      or Western Alabama Highway, and does not guarantee
                      contracting opportunities or financial benefit.
                    </p>
                    <p className="mb-0">
                      ALDOT is not responsible for any business decisions made
                      based on information contained in or derived from this
                      system.
                    </p>
                  </div>
                </div>

                {/* Footer Actions */}
                <div className="d-print-none d-flex justify-content-between pt-4 border-top">
                  {/* <button
                  type="button"
                  onClick={() => window.print()}
                  className="btn btn-outline-dark px-4 fw-bold"
                >
                  Download as PDF
                </button> */}
                  <div></div>
                  <button
                    type="submit"
                    className="btn btn-primary px-5 fw-bold shadow"
                  >
                    {isSubmitting ? "Processing..." : "Submit Application"}
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
      <div className="d-print-none">
        <Footer />
      </div>
    </>
  );
}
